import { Link } from "react-router-dom";
import { isAppSection, type Post, type Section, type StoreItem } from "../lib/types";
import { postPath } from "../lib/data";

export function SectionCard({ section }: { section: Section }) {
  return (
    <Link className="card link-card" to={`/sections/${encodeURIComponent(section.id)}`}>
      <h2>{section.name}</h2>
      {section.imageUrl ? <img src={section.imageUrl} alt="" loading="lazy" /> : null}
      {section.description ? <p>{section.description}</p> : null}
      {isAppSection(section) ? <div className="meta">Web app</div> : null}
    </Link>
  );
}

export function PostCard({ post, collectionName = "posts" }: { post: Post; collectionName?: string }) {
  return (
    <Link className="card link-card" to={postPath(post, collectionName)}>
      <h2>{post.title}</h2>
      {post.imageUrl ? <img src={post.imageUrl} alt="" loading="lazy" /> : null}
      <p>{post.content}</p>
      <div className="meta">
        <span>{post.likeCount || 0} likes</span>
        <span>{post.commentCount || 0} comments</span>
      </div>
    </Link>
  );
}

export function StoreCard({
  item,
  owned = false,
  canAfford = true,
  disabled = false,
  isAdmin = false,
  onBuy,
  onEdit,
  onDelete
}: {
  item: StoreItem;
  owned?: boolean;
  canAfford?: boolean;
  disabled?: boolean;
  isAdmin?: boolean;
  onBuy?: (item: StoreItem) => void;
  onEdit?: (item: StoreItem) => void;
  onDelete?: (item: StoreItem) => void;
}) {
  const buttonText = owned ? "Owned" : canAfford ? "Buy" : "Not enough coins";

  return (
    <article className="card">
      <h2>{item.name}</h2>
      {item.imageUrl ? <img src={item.imageUrl} alt="" loading="lazy" /> : null}
      {item.description ? <p>{item.description}</p> : null}
      <div className="store-action-row">
        <span>{item.price || 0} coins</span>
        <button className="primary-button" type="button" disabled={disabled || owned || !canAfford} onClick={() => onBuy?.(item)}>
          {buttonText}
        </button>
      </div>
      {isAdmin ? (
        <div className="admin-inline-actions store-admin-actions">
          <button type="button" onClick={() => onEdit?.(item)}>
            Edit
          </button>
          <button className="danger-button" type="button" onClick={() => onDelete?.(item)}>
            Delete
          </button>
        </div>
      ) : null}
    </article>
  );
}

export function StateBlock({ loading, error, empty }: { loading?: boolean; error?: string | null; empty?: boolean }) {
  if (loading) return <div className="state">Loading...</div>;
  if (error) return <div className="state">Unable to load: {error}</div>;
  if (empty) return <div className="state">Nothing to show yet.</div>;
  return null;
}
